import Vue from "vue";
import Vuex from "vuex";
import COMMON_API from "@/api/common.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showMiniBarMenu: false,
    alertNotification: {
      active: false,
      message: null,
      type: null
    },
    loadingStatus: false,
    userPermissions: {
      modulos: [],
      acoes: []
    },
    optionsDataTable: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 5,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: [],
      sortDesc: []
    },
    nameOptionsDataTable: null,
    filterDataTable: null,
    tabDataTable: null
  },
  mutations: {
    setAlertNotification(state, payload) {
      state.alertNotification = payload;
      setTimeout(() => {
        state.alertNotification.active = false;
      }, 10000);
    },
    setLoadingStatus(state, payload) {
      state.loadingStatus = payload;
    },
    setUserPermissions(state, payload) {
      state.userPermissions = payload;
    },
    setOptionsDataTable(state, payload) {
      state.optionsDataTable = payload.options;
      state.nameOptionsDataTable = payload.name;
      state.filterDataTable = payload.filter;
      state.tabDataTable = payload.tab;
    },
    setShowMiniBarMenu(state, payload) {
      state.showMiniBarMenu = payload;
    }
    
  },
  actions: {
    showAlertNotification({ commit }, payload) {
      payload.active = true;
      commit("setAlertNotification", payload);
    },
    hasLoading({ commit }, payload) {
      commit("setLoadingStatus", payload);
    },
    async requestUserPermissions({ commit }) {
      const { data } = await COMMON_API.getUserPermissions();
      commit("setUserPermissions", data);
      return data;
    },
    async suggestUsers(context, filter) {
      const { data } = await COMMON_API.suggestUsers(filter);
      return data;
    },
    async suggestCompany(context, { term, groupId }) {
      const { data } = await COMMON_API.suggestCompany({ term, groupId });
      return data;
    },
    async suggestOperationalGroups(context, filter) {
      const { data } = await COMMON_API.suggestOperationalGroups(filter);
      return data;
    },
    saveOptionsDataTable({ commit }, payload) {
      commit("setOptionsDataTable", payload);
    },
    async setShowMiniBarMenu({ commit }, payload) {
      commit("setShowMiniBarMenu", payload);
    }
  },
  modules: {}
});
